import { swiperOptions, initResponsiveSwiper } from './module/SwiperFunctions';

// おすすめ記事共通設定
const recommendSwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
};

// ai
const aiRecommendSwiperOptions = swiperOptions({
  navigation: {
    nextEl: '#side_content_ai_recommend .recommends__swiperButtonNext',
    prevEl: '#side_content_ai_recommend .recommends__swiperButtonPrev',
  },
  ...recommendSwiperOptions,
});

// おすすめ
const itemRecommendSwiperOptions = swiperOptions({
  navigation: {
    nextEl: '#side_content_item_recommend .recommends__swiperButtonNext',
    prevEl: '#side_content_item_recommend .recommends__swiperButtonPrev',
  },
  ...recommendSwiperOptions,
});

/**
 * DOM要素がSwiperコンテナかどうかを判断する純粋関数。
 * Swiperコンテナは、Swiperスライドショーを実装するためのDOM要素です。
 *
 * @param {Element} node - 判定対象のDOM要素。
 * @returns {boolean} - 要素がSwiperコンテナであればtrue、そうでなければfalseを返します。
 */
const isSwiperContainer = (node) => node.nodeType === Node.ELEMENT_NODE && node.classList.contains('swiper');

/**
 * NodeList内の各DOM要素に対して、SwiperコンテナであればSwiperを初期化する関数。
 * この関数は、DOMの変更を検知した際に追加された要素にSwiperを適用するために使用されます。
 *
 * @param {NodeList} nodeList - Swiperを検索および初期化する対象のDOM要素のリスト。
 * @param {Object} options - Swiper初期化時に適用するオプションのオブジェクト。
 */
const initRecommendSwiper = (nodeList, options) => {
  nodeList.forEach((node) => {
    if (isSwiperContainer(node)) {
      initResponsiveSwiper(node, options);
    }
  });
};

/**
 * MutationObserverによって検出されたDOMの変更（mutations）を処理し、
 * 追加されたノードにSwiperを適用する関数。
 *
 * @param {MutationRecord[]} mutations - DOMの変更を表すMutationRecordオブジェクトの配列。
 * @param {Object} swiperConfig - Swiper初期化に使用する設定オプション。
 */
const handleMutations = (mutations, swiperConfig) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length > 0) {
      initRecommendSwiper(mutation.addedNodes, swiperConfig);
    }
  });
};

/**
 * 特定のDOM要素（target）内の子要素の変更を監視し、新たに追加された子要素に対して
 * Swiperを初期化するためのMutationObserverを設定する関数。
 *
 * @param {Element} target - 子要素の変更を監視するDOM要素。
 * @param {Object} swiperConfig - Swiper初期化に使用する設定オプション。
 */
const observeMutations = (target, swiperConfig) => {
  const observer = new MutationObserver((mutations) => handleMutations(mutations, swiperConfig));
  observer.observe(target, {
    childList: true,
    subtree: true,
  });
};

document.addEventListener('DOMContentLoaded', () => {
  // aiが選んだおすすめ記事
  const aiRecommendContainer = document.getElementById('side_content_ai_recommend');
  if (aiRecommendContainer) {
    observeMutations(aiRecommendContainer, aiRecommendSwiperOptions);
  }

  // このページをみている人はこのページも見ています
  const itemRecommendContainer = document.getElementById('side_content_item_recommend');
  if (itemRecommendContainer) {
    observeMutations(itemRecommendContainer, itemRecommendSwiperOptions);
  }
});
